/// <reference path="../../core/services/companyservices.js" />
import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useImperativeHandle, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import classnames from "classnames";
import Skeleton from 'react-loading-skeleton'
import FormFileUpload from "./../inputs/fileupload";
import FormSelect from './../inputs/select';
import FormText from './../inputs/text';
import TimesheetInput from './../inputs/timesheet-input';
import DocumentsAdmin from '../../components/documents/documents.admin';
import Popup from './../modal/modal.js';
import moment from 'moment';
import { Box, IconButton, Tooltip as MuiTooltip/*, EditIcon,DeleteIcon*/ } from '@mui/material';

import { toast } from "react-toastify";
import Spinner from 'react-bootstrap/Spinner';

import {
    getUnits, prepareForm, asFloat, useFirstRender,
    asNum, getLocale, isWeekend, getDayName,
    generateValueDict, getTotalForCurrMonth, getTotalForCurrMonthDevExpense, getDaysInCurrentMonth,
    formatMonthYear, keyToProps,
    getUniqueList, trimElip, TruncatedText,
    getAvailableMonths, getFullName, formatDateTime, lpad,
    isInRange, setConfig, removeSeparators, setLocalStorage, formatMonthYearNum
} from './../../utils';

import ConfirmPopup from './../modal/modal';
import { saveAs } from 'file-saver';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
} from "@progress/kendo-react-intl";
import NumberFormatted from './../../shared/components/numberFormatted';

const TimesheetItem = React.forwardRef((props, ref) => {
    const [pdfData, setPdfData] = useState(null);

    const [isLoading, setLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(null);
    const skeletonCount = 5;
    let navigate = useNavigate();
    const { usersAdminStore, timesheetStore, activitiesStore, fileStore, loginStore } = useStores();
    const { accountInfo } = loginStore;
    const { getDummy, dummies, message } = usersAdminStore;
    const { setMonthStatus, saveHours, month, getBilledReport } = timesheetStore;
    const { upload, getAll, deleteDocument, getDocumentFile } = fileStore;
    //const { getUserActivities, userActivities } = activitiesStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [currentDate, setCurrentDate] = useState(null);
    const shouldEditTimesheet = () => { return props.state == 0 && (props.editable ?? false); }
    const [validated, setValidated] = useState(false);
    const [messageValidated, setMessageValidated] = useState(false);
    const [rejectValidated, setRejectValidated] = useState(false);
    const [hours, setHours] = useState({});

    const [modalSettings, setModalSettings] = useState({});
    const [showValidateConfirm, setShowValidateConfirm] = useState(false);

    const [billableProject, setBillableProject] = useState(-1);
    const [client, setClient] = useState(-1);
    const [dev, setDev] = useState(-1);
    const [formValidated, setFormValidated] = useState(false);
    const firstRender = useFirstRender();
    const [savingFirst, setSavingFirst] = useState(false);
    const hoursForm = useRef(null);
    const firstLoad = useRef(false);
    const [status, setStatus] = useState(-1); //0 Initial - 1 PendingVal - 2 Rejected - 3 Validated
    const [billable, setBillable] = useState(0);

    const [showReject, setShowReject] = useState(false);
    const [rejectMessage, setRejectMessage] = useState(null);
    const [initialDate, setInitialDate] = useState(null);

    const [showMessage, setShowMessage] = useState(false);
    const [showFiles, setShowFiles] = useState(false);
    const [saveCurrent, setSaveCurrent] = useState(false);
    const [showReport, setShowReport] = useState(false);

    const loadActivities = () => {
        reload();
    }

    const clearFilters = () => {
        setClient(-1);
        setDev(-1);
    }

    const reload = (force) => {
        if ((([2, 3]).indexOf(props?.role) > -1) || force) {
            if (props.afterSave) { props.afterSave() }
        }
    }

    const handleMessageSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = Object.fromEntries(new FormData(event.target).entries());
            message(formData).then(() => {
                setShowMessage(false);
                setMessageValidated(false);
            })

        }
        setMessageValidated(true);
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = Object.fromEntries(new FormData(event.target).entries());
            var files = new FormData(event.target)?.getAll("file") ?? [];

            var data = new FormData();

            if (files && files?.length) {
                files?.forEach((f, i) => {
                    data.append(`file`, files[i])
                })
            }
            data.append("activityId", formData.activityId);
            data.append("month", currentDate?.getMonth() + 1);
            data.append("year", currentDate?.getFullYear());

            if (isAdmin()) {
                data.append("devId", props.filter.split('_')[0]);
            }

            upload(data).then(() => {
                setValidated(false);
                handleClose();
                setSaveCurrent(true)
                props.afterSave?.()
            })
        }
        setValidated(true);
    };

    const handleRejectSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = Object.fromEntries(new FormData(event.target).entries());
            setRejectMessage(formData?.reason);
            setShowReject(false);
        }
        setRejectValidated(true);

    }

    const hasEmptyMonths = (values) => {
        var result = [];
        values.reduce(function (res, item) {
            var key = `${item.activityId}_${item.month}_${item.year}`;
            if (!res[key]) {
                res[key] = { Id: key, total: 0 };
                result.push(res[key])
            }
            res[key].total += item.value;
            return res;
        }, {});

        return result?.some(x => x.total === 0) ?? true;
    }

    const handleSubmitHours = (event) => {
        /*setStatus(-1);*/
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event);
            var values = Object.keys(formData).map(x => {
                var parts = x.toString().split("_");
                return { monthRecordId: asNum(parts[0]), hourRecordId: asNum(parts[1]), activityId: asNum(parts[2]), day: asNum(parts[3]), month: asNum(parts[4]), year: asNum(parts[5]), value: asFloat(removeSeparators(formData[x])) }
            })

            saveHours({ hours: values, toStatus: status == 0 || status == -1 ? null : status }, () => {
                if (props.state == 3) { setBillableProject(-1) }
                if (props.afterSave) { props.afterSave() }
                else { loadActivities(); }
                setFormValidated(false);
            })
                .then(() => {
                    if (accountInfo?.role === 3) {
                        setTimeout(() => {

                            window.location.reload();
                        }, 1200);
                    }
                });
        }

        setFormValidated(true);
    };




    const changeStatusTo = (status) => {
        setStatus(-1);

        var activities = getFilteredActivities();
        if (status === 2) { activities = activities?.filter(x => !x.confidential); } //ignore confidential if reject

        var activitiesNoMonth = activities?.filter(x => (status === 2 ? !x.confidential : true))?.filter(x => !getCurrentMonthForActivity(x)?.id);

        if (activitiesNoMonth?.length > 0) {
            return;

        } else {
            var ids = [];
            switch (status) {
                case 1:
                    ids = getMonthIdsPerStatus([0, 2]);
                    break;
                case 2:
                case 3:
                    var monthStatus = 1;
                    if (isAdmin()) {
                        switch (props.state) {
                            case 5: //Regression from non billable
                                monthStatus = 5;
                                break;
                            case 3: //Reject validation                            
                                monthStatus = 3;
                                break;
                            default: //Regression from 4
                                monthStatus = 4;
                                break;
                        }
                        //monthStatus = props.state === 5 ? 5 : 4;
                    }
                    ids = getMonthIdsPerStatus([monthStatus]);
                    break;
                case 5:
                    ids = getMonthIdsPerStatus([4]);
                    break;
                default:

                    break;
            }

            if (ids?.length > 0) {
                setMonthStatus({ monthIds: ids, status: status, rejectedMessage: rejectMessage, from: props.state }, () => {
                    setRejectMessage(null);
                    if (status == 5 || (isAdmin && (status === 3 || status === 2))) { reload(true) } else { loadActivities(); }
                });
            } else { console.log("no months to send") }
        }
    }

    useEffect(() => {
        if ([0, 1, 4].indexOf(status) > -1) { //Saving, Send To Validate and Admin Validate/Prebill
            hoursForm?.current?.requestSubmit();
        } else if ([2, 3, 5].indexOf(status) > -1) { //Approve and reject (2,3 for client) approve (5 for admin)
            changeStatusTo(status)
        }

    }, [status]);

    useEffect(() => {
        setLoading(props.isLoading);
    }, [props.isLoading]);

    useEffect(() => {
        //if (initialDate) //If set, ignore
        //    return;

        var date = props.initialDate;

        if (date) {
            setInitialDate(date);
            setCurrent(date);
        }

    }, [props.initialDate])

    useEffect(() => {
        if (rejectMessage?.length > 0) {
            setStatus(2);
        }
    }, [rejectMessage]);

    useEffect(() => {
        var list = props?.items?.length > 0 ? (props?.items ?? []) : [];
        if (list?.length > 0) {

            if (!saveCurrent) {
                //alert("settingHours")
                setHours(generateValueDict(list, accountInfo?.role));
            } else
                setSaveCurrent(false);
            //setInitialMonth(list);
        }
    }, [props.items]);


    useEffect(() => {
        /*if (firstRender) {
            console.log("firstRender")
            loadActivities();
        }*/

    }, [firstRender]);

    const setCurrent = (date) => {
        setCurrentDate(date);
        setConfig("date", `current_${accountInfo.name}`, date);
    }

    const countByStatus = (status) => {
        return getFilteredActivities()?.filter(a => {
            if (status === 3)
                return (getCurrentMonthForActivity(a)?.status ?? 0) >= status
            else
                return (getCurrentMonthForActivity(a)?.status ?? 0) == status
        })?.length
    };
    const hasAnyInputs = () => getFilteredActivities()?.map(x => isEditable(x) && isMonthEnabled(x, 0)).some(x => x == true);

    const isAdmin = () => props.role == 1;
    const updateValues = (rowKey, e) => {
        var v = asFloat(e)
        var values = hours ?? {};

        if (hours[rowKey]) {
            values[rowKey].value = v;
        } else {
            values[rowKey] = { value: v };
        }

        setHours(Object.assign({}, values));
    }
    const getHourValueFn = (key) => hours[key] ? hours[key].defaultValue : "";
    const getDefaultValue = (key) => isNaN(parseFloat(getHourValueFn(key))) ? null : parseFloat(getHourValueFn(key))?.toFixed(2);
    const getMonthIdsPerStatus = (statusList) => getFilteredActivities().filter(x => (statusList ?? []).indexOf(getCurrentMonthForActivity(x)?.status) > -1)?.map(a => getCurrentMonthForActivity(a)?.id);

    const buildRowKey = (activity, day) => currentDate ? `${getCurrentMonthForActivity(activity)?.id ?? "N"}_${getRecord(activity, day + 1)?.id ?? "N"}_${activity.id}_${day + 1}_${currentDate.getMonth() + 1}_${currentDate.getFullYear()}` : "";
    const getCurrentMonthForActivity = (activity) => { return currentDate ? activity?.months?.find(m => m.month === currentDate.getMonth() + 1 && m.year === currentDate.getFullYear()) : null; }
    const hasRejectable = (checkStatus) => getFilteredActivities()?.filter(x => !x.confidential)?.filter(x => checkStatus ? getCurrentMonthForActivity(x)?.status === checkStatus : true)?.length > 0 ?? false;

    const getValue = (activity, idx, getSum) => {
        return hours[buildRowKey(activity, idx)];
    }
    const isEditable = (activity) =>
    /*([2, 3].indexOf((props?.role)) > -1 && [0, 2].indexOf(getCurrentMonthForActivity(activity)?.status ?? 0) > -1)
    ||*/
    /*(props.role == 2 && getCurrentMonthForActivity(activity)?.status == 1)*/
    //activity.workUnit != 4 &&
    (([3].indexOf((props?.role)) > -1 && [0, 2].indexOf(getCurrentMonthForActivity(activity)?.status ?? 0) > -1)
        || (props.role === 1 && getCurrentMonthForActivity(activity)?.status === 3)
        || (props.role === 1 && activity.confidential && getCurrentMonthForActivity(activity)?.status == null));



    const getRecord = (activity, day) => activity.workUnit === 4 ? null : getCurrentMonthForActivity(activity)?.hoursPerDay?.find(r => r.day === day);

    const isMonthEnabled = (a, day) => {
        if (!currentDate)
            return false;

        var curr = new Date(currentDate.getFullYear(), currentDate.getMonth(), day + 1);
        var min = new Date(a.startYear, a.startMonth - 1, 1);
        var max = new Date(a.endYear, a.endMonth, 0);
        return (curr <= max && curr >= min)
    }


    const getFullStatusList = () => {
        if (props.state == 3) {
            var list = filterPerStatus(props?.items ?? []/*(userActivities ?? [])*/);
            return list;
        }
    }

    const getProjects = (ignoreProjects) => {
        var options = [...new Map(ignoreProjects ? [] : filterPerStatus(getFilteredActivities(true))?.flatMap(a => a.project)?.filter(x => x.id > 0)?.map(item => [item["id"], item])).values()];
        options?.unshift({ id: -2, name: `* ${t("noProject")}` });
        options?.unshift({ id: -1, name: `* ${t("all")}` });
        return options;
    }

    const getClients = () => {
        var options = [...new Map(getFilteredActivities(true)?.flatMap(a => a.project.client)?.filter(x => x.id > 0).map(item => [item["id"], item])).values()];
        options.unshift({ id: -1, name: t("all") })
        return options;
    }

    const getActivitiesForUpload = () => {
        if (currentDate) {
            var items = props.items.filter(x => isInRange(x, currentDate.getMonth() + 1, currentDate.getFullYear()));
            var options = [...new Map(items?.filter(x => x.id > 0).map(item => [item["id"], item])).values()]?.map(x => { return { id: x.id, name: `${x.project.client.name} - ${x.name}`, workUnit: x.workUnit } });
            return options;
        } else
            return [];
    }

    const getFilesForActivities = () => {
        var options = [...new Map(getFilteredActivities(false)?.filter(x => x.id > 0).map(item => [item["id"], item])).values()]?.map(x => x.documents)?.filter(x => x.length > 0)?.reduce((p, c) => p.concat(c), []);/*?.map(x => { return { id: x.id, name: x.name } })*/;
        return options.filter(x => (x.month === currentDate?.getMonth() + 1 && x.year === currentDate?.getFullYear()));
    }

    const getFilesForActivitiesFormatted = () => {
        var options = getFilteredActivities(false)?.filter(x => x.id > 0);
        var result = [];

        for (var i = 0; i < options.length; i++) {
            var a = options[i];

            for (var j = 0; j < a.documents.length; j++) {
                var doc = a.documents[j];

                result.push({ id: doc.id, filename: doc.filename, month: doc.month, year: doc.year, activityName: a?.name, clientName: a?.project?.client?.name, consultantName: a.consultant.name, consultantSurname: a.consultant.surname });
            }
        }

        return result.filter(x => (x.month === currentDate?.getMonth() + 1 && x.year === currentDate?.getFullYear()));
    }

    const getDevs = () => {
        var options = [...new Map(getFilteredActivities(true)?.flatMap(a => a.consultant)?.map(item => [item["id"], item]))?.values()]?.map(x => { return { id: x.id, name: getFullName(x) } });
        options.unshift({ id: -1, name: t("all") })
        return options;
    }
    const filterPerStatus = (items) => {
        return (items ?? [])?.filter(x => [props.state].indexOf(getCurrentMonthForActivity(x)?.status ?? ((x.confidential) ? 3 : 0)) > -1) ?? [];
    }

    const getTotalForActivity = (activity, currentDate) => {
        return activity.workUnit === 4 ?
            ((accountInfo.role === 3 || accountInfo.role === 2) ?
                getTotalForCurrMonthDevExpense(activity.months, activity, currentDate)
                :
                (!!activity.billedExpenseAmount ? activity.billedExpenseAmount.toFixed(2) : '')
            )
            :
            getTotalForCurrMonth(hours, activity, currentDate)
    }

    const getFilteredActivities = (ignoreFilter) => {

        var list = [];
        if (props?.role == 3) { //Dev
            if (client == -1 || ignoreFilter)
                list = props.items ?? [];
            else
                list = props.items.filter(a => a.project.client.id == client) ?? [];
        } else if (props?.role == 2) { //Client
            var items = props?.items?.filter(x => x.months?.length > 0 && getCurrentMonthForActivity(x));
            if (dev == -1 || ignoreFilter)
                list = items ?? [];
            else
                list = items.filter(a => a.consultant.id == dev) ?? [];
        } else if (props?.role == 1) { //Admin, use props from parent
            list = filterPerStatus(props?.items);//(props?.items ?? [])?.filter(x => [props.state].indexOf(getCurrentMonthForActivity(x)?.status ?? ((x.confidential) ? 3 : 0)) > -1) ?? [];            

            if (!ignoreFilter) {
                //Filter by project to invoice
                if ([3, 4, 5].indexOf(props.state) > -1) {
                    if (billableProject > -1)
                        list = list.filter(x => x.project.id == billableProject)
                    else if (billableProject == -2)
                        list = list.filter(x => x.projectId == null)
                }
            }
        }

        //Only show activities for month
        if ([2, 3].indexOf(props.role) > -1)
            list = list.filter(x => isMonthEnabled(x, 1));


        //If client, hide empty months
        if (props.role === 2)
            list = list.filter(x => Number(getTotalForActivity(x, currentDate)) > 0);



        return list;

    }


    const getBillingConfirmationText = () => {
        var nonBillable = getFilteredActivities()?.filter(x => !x.billableClient);
        var text = `<b>${t('invoiceClientConfirmation')}</b><br/>`;
        text += "<br/>";

        getUniqueList(getFilteredActivities()?.filter(x => x.billableClient).flatMap(x => x.project), "id").forEach(p => {
            text += `<small><b>${p.name} - ${p.client.name}</b><br/></small>`;
            getFilteredActivities()?.filter(x => x.billableClient && x.project.id == p.id).forEach(a => {
                text += `<small>${a.name} (${a.billingText})</small><br/>`;
            });
        });

        return text;
    }

    const isAmountOrExpense = (a) => a.workUnit === 3 || a.workUnit === 4;
    const closeShowReport = () => {
        setPdfData(null);
        setShowReport(false);
    }

    return (
        <Stack direction="vertical" gap={2}>
            {(props.state !== 5 && props.role == 3) &&
                <Card>
                    <Card.Body>
                        <div>
                            <Row>
                                <Col xs={2}>
                                    <Stack direction="vertical" >
                                        {isLoading ? <Skeleton /> : <b>{t('status')}:</b>}
                                    </Stack>
                                </Col>
                                <Col>
                                    <Stack direction="horizontal" gap={2}>
                                        {isLoading ? <Skeleton width={20} /> : <FontAwesomeIcon className="mx-1" size="2x" icon={solid("spinner")} />}
                                        <Stack direction="vertical">
                                            {isLoading ? <Skeleton width={100} /> : <b>{countByStatus(1)}</b>}
                                            {isLoading ? <Skeleton width={100} /> : <b>{t('activitiesPending')}</b>}
                                        </Stack>
                                    </Stack>
                                </Col>

                                <Col>
                                    <Stack direction="horizontal" gap={2}>
                                        {isLoading ? <Skeleton width={20} /> : <FontAwesomeIcon className="mx-1" size="2x" icon={solid("ban")} />}
                                        <Stack direction="vertical">
                                            {isLoading ? <Skeleton width={100} /> : <b>{countByStatus(2)}</b>}
                                            {isLoading ? <Skeleton width={100} /> : <b>{t('rejected')}</b>}
                                        </Stack>
                                    </Stack>
                                </Col>

                                <Col>
                                    <Stack direction="horizontal" gap={2}>
                                        {isLoading ? <Skeleton width={20} /> : <FontAwesomeIcon className="mx-1" size="2x" icon={regular("circle-check")} />}
                                        <Stack direction="vertical">
                                            {isLoading ? <Skeleton width={100} /> : <b>{countByStatus(3)}</b>}
                                            {isLoading ? <Skeleton width={100} /> : <b>{t('validated')}</b>}
                                        </Stack>
                                    </Stack>
                                </Col>

                                <Col>
                                    {<Button className="float-end" variant="secondary" onClick={() => setShowMessage(true)}>
                                        <FontAwesomeIcon className="mx-1" icon={solid("message")} /></Button>}
                                </Col>
                            </Row>
                        </div>
                    </Card.Body>
                </Card>

            }

            {(props.state !== 5 && props.role == 2) &&
                <Card>
                    <Card.Body>
                        <div>
                            <Row>
                                <Col xs={2}>
                                    <Stack direction="vertical" >
                                        {isLoading ? <Skeleton /> : <b>{t('status')}:</b>}
                                    </Stack>
                                </Col>
                                <Col>
                                    <Stack direction="horizontal" gap={2}>
                                        {isLoading ? <Skeleton width={20} /> : <FontAwesomeIcon className="mx-1" size="2x" icon={solid("spinner")} />}
                                        <Stack direction="vertical">
                                            {isLoading ? <Skeleton width={100} /> : <b>{countByStatus(1)}</b>}
                                            {isLoading ? <Skeleton width={100} /> : t('activitiesPending')}
                                        </Stack>
                                    </Stack>
                                </Col>

                                <Col>
                                    {<Button className="float-end" variant="secondary" onClick={() => setShowMessage(true)}>
                                        <FontAwesomeIcon className="mx-1" icon={solid("message")} /></Button>}
                                </Col>
                            </Row>
                        </div>
                    </Card.Body>
                </Card>}

            <Card>
                <Card.Body>
                    <ConfirmPopup show={showValidateConfirm} isDeleting={false} onClose={() => setShowValidateConfirm(false)} title={modalSettings?.title} body={modalSettings?.body} onClick={modalSettings.onConfirm} />

                    <Modal show={showFiles} onHide={() => { setShowFiles(false); setPdfData(null) }} size={"xl"}>

                        <Modal.Header closeButton>
                            <Modal.Title>{t("files")} {isLoading && <Spinner animation="border" role="status" size="sm"></Spinner>}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {/*JSON.stringify(getFilesForActivities())*/}
                            {getFilesForActivitiesFormatted()?.length > 0 ? <Table>
                                <tbody>
                                    <tr>
                                        <th>{t("file")}</th>
                                        <th>{t("activity")}</th>
                                        {props.role === 2 && <th>{t("consultant")}</th>}
                                        <th></th>
                                    </tr>
                                    {getFilesForActivitiesFormatted()?.map((f, i) => {
                                        return (
                                            <tr key={i} style={{ verticalAlign: "middle" }}>
                                                <td >
                                                    <Button variant="link" style={{ color: "#D12B3C", padding: 0, textAlign: "left" }} onClick={(e) => {
                                                        e.preventDefault();
                                                        getDocumentFile(f.id).then((b) => {
                                                            var fileReader = new FileReader();
                                                            fileReader.onload = function (event) {
                                                                setPdfData({
                                                                    data: event.target.result,
                                                                    filename: f.filename
                                                                });
                                                            };
                                                            fileReader.readAsArrayBuffer(b.bytes);
                                                        })
                                                    }}>{f.filename}</Button></td>
                                                <td>{f.clientName} - {f.activityName}</td>
                                                {props.role === 2 && <td>{`${f.consultantName} ${f.consultantSurname}`}</td>}
                                                <td>

                                                    <Button className="float-end border ms-auto" variant="outline" onClick={() => {
                                                        setModalSettings({
                                                            title: t("delete"),
                                                            body: t('confirmDelete'),
                                                            onConfirm: () => {
                                                                deleteDocument(f.id).then(() => {
                                                                    //setShowFiles(false);
                                                                    setSaveCurrent(true);
                                                                    props.afterSave?.()
                                                                })
                                                            }
                                                        });
                                                        setShowValidateConfirm(true)

                                                    }}>
                                                        <FontAwesomeIcon icon={solid("trash")} />
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                                :
                                <span>{t("noRecords")}</span>
                            }

                            {pdfData && <LocalizationProvider language={i18n.language}><PDFViewer style={{ height: pdfData ? "58vh" : null }}
                                saveFileName={pdfData?.filename}
                                arrayBuffer={pdfData?.data} tools={[
                                    "pager",
                                    "spacer",
                                    "zoomInOut",
                                    "zoom",
                                    "selection",
                                    "spacer",
                                    "search",/*,
                            "open",*/
                                    "download"/*,
                            "print",*/]}
                            /></LocalizationProvider>}
                        </Modal.Body>
                    </Modal>

                    <Modal show={show} onHide={handleClose}>
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{t("uploadDocument")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Stack gap={2}>

                                    <FormFileUpload multiple required label={t("files")} id="file" isLoading={isLoading} innerText={t("dragDropDocuments")} accept=".pdf" />
                                    <FormSelect required label={`${t("relatedActivity")}:`}
                                        id="activityId" isLoading={isLoading} items={getActivitiesForUpload()} itemId="id" itemLabel="name"
                                        itemLabelFn={(obj) => `${obj?.name} (${getUnits(null, true).find(x => x.id === obj?.workUnit)?.name})`} />
                                    {/*<input type="date" hidden name="date" value={currentDate?.toISOString()?.substring(0, 10)} onChange={() => { }} />*/}
                                </Stack>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" type="submit" /*onClick={() => { alert("dsa") }}*/>
                                    {t("uploadDocument")}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>

                    <Modal show={showMessage} onHide={() => setShowMessage(false)}>
                        <Form noValidate validated={messageValidated} onSubmit={handleMessageSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{t("sendMessageToAdministrator")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Stack gap={2}>
                                    <FormText lines={3} placeholder={t("enterMessage")} required label={t("message")} id="message" isLoading={isLoading} />
                                </Stack>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" type="submit" /*onClick={() => { alert("dsa") }}*/>
                                    {t("send")}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>



                    <Modal show={showReject} onHide={() => setShowReject(false)}>
                        <Form noValidate validated={rejectValidated} onSubmit={handleRejectSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{t("reject")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>

                                <Stack gap={2}>
                                    <span>{t("confirmRejectMessage", { number: props.role === 1 ? countByStatus(3) : countByStatus(1) })}</span>
                                    <FormText lines={4} required label={`${t("reason")}:`} id="reason" isLoading={isLoading} />
                                </Stack>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => { setShowReject(false) }}>{t("no")}</Button>
                                <Button variant="success" type="submit">{t("yes")}</Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>

                    <Modal className="modal-xl" show={showReport} onHide={() => closeShowReport()}>
                        <Modal.Header closeButton>
                            <Modal.Title>{pdfData?.filename}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {pdfData && <LocalizationProvider language={i18n.language}><PDFViewer style={{ height: pdfData ? "75vh" : null }}
                                saveFileName={pdfData?.filename}
                                arrayBuffer={pdfData?.data} tools={["pager", "spacer", "zoomInOut", "zoom", "selection", "spacer", "search", "download"]}
                            /></LocalizationProvider>}
                        </Modal.Body>
                    </Modal>

                    {props.state <= 5 &&


                        <div>


                            {props.role == 3 &&

                                <Row className="mb-4">
                                    <Col xs={2}>
                                        <Stack direction="vertical" >
                                            {isLoading ? <Skeleton /> : <b>{t('client')}:</b>}
                                            <FormSelect required hideNone isLoading={isLoading} items={getClients()} itemId="id" itemLabel="name" onChange={(v) => { setClient(v) }} value={client} useVal />
                                        </Stack>
                                    </Col>

                                    <Col>





                                        {client &&
                                            <Stack direction="horizontal" className="float-end">

                                                {hasAnyInputs() && <Button className="float-end mx-2" variant="secondary"/* type="submit"onClick={() => { devTimesheet?.current?.save() }}*/ onClick={() => setStatus(0)}>
                                                    <FontAwesomeIcon className="mx-1" icon={solid("save")} />&nbsp;{t("saveMonth")}</Button>}
                                                {hasAnyInputs() && <Button className="float-end mx-2" variant="secondary" onClick={() => {
                                                    setModalSettings({
                                                        title: t("validate"),
                                                        body: `${t('confirmValidationMessage', { number: countByStatus(0) + countByStatus(2)/*initial or rejected*/ })}`,
                                                        onConfirm: () => { setStatus(1)/*setSavingFirst(true)*/ }
                                                    });
                                                    setShowValidateConfirm(true);
                                                }}>
                                                    {t("sendToValidate")}</Button>}
                                            </Stack>
                                        }

                                        {props.state < 2 && !props.noUpload && <Button className="float-end border-dashed" variant="outline" onClick={() => { handleShow(); }}>
                                            <FontAwesomeIcon className="mx-1" icon={solid("file-upload")} />
                                            {t("dragDropDocuments")}</Button>}

                                        {props.state < 2 && !props.noUpload && getFilesForActivities()?.length > 0 && <Button style={{ marginRight: 15 }} className="float-end border" variant="outline" onClick={() => { setShowFiles(true); }}>
                                            <FontAwesomeIcon className="mx-1" icon={solid("file")} />
                                        </Button>}

                                    </Col>
                                </Row>
                            }

                            {props.role === 2 &&

                                <Row className="mb-4">
                                    <Col xs={2}>
                                        <Stack direction="vertical" >
                                            {isLoading ? <Skeleton /> : <b>{t('consultant')}:</b>}
                                            <FormSelect required hideNone isLoading={isLoading} items={getDevs()} itemId="id" itemLabel="name" onChange={(v) => { setDev(v) }} value={dev} useVal />

                                        </Stack>

                                    </Col>
                                    <Col>
                                        {hasRejectable(1) && <Button className="float-end mx-2" variant="danger" onClick={() => {

                                            setShowReject(true);

                                        }}>
                                            {t("reject")}</Button>}

                                        {getMonthIdsPerStatus([1])?.length > 0 && <Button className="float-end" variant="success" onClick={() => {
                                            setModalSettings({
                                                title: t("approve"),
                                                body: `${t('confirmApproveMessage', { number: countByStatus(1) /*getFilteredActivities()?.length*/ })}`,
                                                onConfirm: () => { setStatus(3) }
                                            });
                                            setShowValidateConfirm(true);
                                        }}>
                                            {t("approve")}</Button>}
                                    </Col>
                                </Row>
                            }


                            <Stack direction="horizontal">
                                <Stack gap={2}>
                                    <Row>
                                        <Col>
                                            {props.state === 3 &&
                                                <Row>
                                                    <Col sm={5}></Col>

                                                    <Col sm={7}>
                                                        <Stack direction="horizontal" gap={3}>
                                                            <span>
                                                                <Button variant="danger" disabled={!hasRejectable()} onClick={() => {
                                                                    setShowReject(true);
                                                                }}>
                                                                    <FontAwesomeIcon className="mx-1" icon={solid("arrow-left")} />
                                                                    {t("reject")}
                                                                </Button>
                                                                <Button style={{ marginLeft: '5px' }} variant="danger" disabled={getFilteredActivities()?.length == 0}
                                                                    onClick={() => { reload(true); }}>
                                                                    {t("cancel")}
                                                                </Button>
                                                            </span>

                                                            <span className="ms-auto" />
                                                            <span>
                                                                <FormSelect className="hide-validation-icon" hideNone isLoading={isLoading} items={getProjects()} itemId="id" itemLabel="name" onChange={(v) => { setBillableProject(v) }} />
                                                            </span>

                                                            <span>
                                                                <Button className="float-end border-dashed" variant="outline" onClick={() => { handleShow(); }}>
                                                                    <FontAwesomeIcon className="mx-1" icon={solid("file-upload")} />
                                                                    {t("dragDropDocuments")}</Button>
                                                            </span>

                                                            <span>
                                                                <Button style={{ marginRight: '5px' }} variant="secondary" disabled={getFilteredActivities()?.length == 0}
                                                                    onClick={() => { hoursForm?.current?.requestSubmit(); }}>
                                                                    {t("save")}</Button>
                                                                <Button style={{ background: "#ED7D31" }} variant="secondary" disabled={!hasAnyInputs()} onClick={() => {
                                                                    setModalSettings({
                                                                        title: t("validateConfirmation"),
                                                                        body: t("confirmAdminValidation", { number: getFilteredActivities()?.length }),
                                                                        onConfirm: () => { setStatus(4) }
                                                                    });
                                                                    setShowValidateConfirm(true);
                                                                    //setStatus(4);
                                                                }}>
                                                                    <FontAwesomeIcon className="mx-1" icon={solid("check")} />
                                                                    {t("validate")}</Button>
                                                            </span>
                                                        </Stack>
                                                    </Col>
                                                </Row>}

                                            {(props.state === 4) &&
                                                <Row>
                                                    <Col sm={5}></Col>

                                                    <Col sm={7}>
                                                        <Stack direction="horizontal" gap={3}>
                                                            <Button variant="secondary" disabled={getFilteredActivities()?.length == 0} onClick={() => {
                                                                setModalSettings({
                                                                    title: t("statusChange"),
                                                                    body: t("statusChangeConfirmation"),
                                                                    onConfirm: () => { setStatus(3) }
                                                                });
                                                                setShowValidateConfirm(true);
                                                            }}>
                                                                <FontAwesomeIcon className="mx-1" icon={solid("arrow-left")} />
                                                                {t("pendingValidation")}</Button>

                                                            <div className="ms-auto"><FormSelect className="hide-validation-icon" hideNone isLoading={isLoading} items={getProjects()} itemId="id" itemLabel="name" onChange={(v) => { setBillableProject(v) }} /></div>

                                                            <Button style={{ background: "#ED7D31" }} variant="secondary" disabled={getFilteredActivities()?.length == 0} onClick={() => {
                                                                setModalSettings({
                                                                    title: t("multipleInvoice"),
                                                                    body: getBillingConfirmationText(),
                                                                    onConfirm: () => { setStatus(5) }
                                                                });
                                                                setShowValidateConfirm(true);
                                                            }}>
                                                                <FontAwesomeIcon className="mx-1" icon={solid("file-import")} />
                                                                {t((billableProject > -1 ? "singleInvoice" : "multipleInvoice"))}</Button>

                                                        </Stack>
                                                    </Col>
                                                </Row>}

                                            {(props.state === 5) &&
                                                <Row>
                                                    <Col sm={5}></Col>

                                                    <Col sm={7}>
                                                        <Stack direction="horizontal" gap={3}>
                                                            <Button variant="secondary" onClick={() => {
                                                                setModalSettings({
                                                                    title: t("statusChange"),
                                                                    body: t("nonBillableStatusChangeConfirmation"),
                                                                    onConfirm: () => { setStatus(3) }
                                                                });
                                                                setShowValidateConfirm(true);
                                                            }}>
                                                                <FontAwesomeIcon className="mx-1" icon={solid("arrow-left")} />
                                                                {t("pendingValidation")}
                                                            </Button>


                                                            <div className="ms-auto">
                                                                <FormSelect className="hide-validation-icon"
                                                                    hideNone isLoading={isLoading}
                                                                    items={getProjects(true)} itemId="id" itemLabel="name"
                                                                    onChange={(v) => { setBillableProject(v) }} />
                                                            </div>

                                                        </Stack>
                                                    </Col>
                                                </Row>}

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={5}>
                                            <Container className="border">
                                                <Stack>
                                                    <Stack direction="horizontal" style={{ margin: "4px 0px", borderRadius: "25px", padding: "0px 0px" }}>
                                                        <span style={{ display: props.role == 3 ? "none" : "inline" }}><b>{isLoading ? <Skeleton width={200} /> : t("summaryActivities")}</b></span>
                                                        <Button variant="outline" style={{ visibility: "hidden" }} onClick={() => { }}>
                                                            <FontAwesomeIcon className="ms-auto" color="#B96A6A" icon={solid("caret-right")} size="1x" />
                                                        </Button>
                                                    </Stack>


                                                    <Table responsive className="timesheet table-sm smaller">
                                                        <thead>
                                                            <tr key={1}>
                                                                <th style={{ width: '25%' }}>{isLoading ? <Skeleton /> : t(props.role == 2 ? 'consultant' : 'client')}</th>
                                                                {/*props.role == 2 ? <th></th> : <th >{isLoading ? <Skeleton /> : t('project')}</th>*/}
                                                                <th style={{ width: '25%' }}>{isLoading ? <Skeleton /> : t('activity')}</th>
                                                                <th style={{ width: '25%' }}>{isLoading ? <Skeleton /> : t('unit')}</th>
                                                                <th style={{ width: '20%' }} className="text-end" >{isLoading ? <Skeleton /> : t('total')}</th>

                                                                <th style={{ width: '5%' }}>{isLoading ? <Skeleton /> : ""}</th>



                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(isLoading || !getFilteredActivities()) &&
                                                                Array.from({
                                                                    length: skeletonCount
                                                                })?.map((_, idx) => (
                                                                    <tr key={idx}>
                                                                        <td ><Skeleton /></td>
                                                                        {/*props.role == 2 ? <td  style={{ visibility: "hidden", width: "0px" }}><Skeleton /></td> : <td><Skeleton /></td>*/}
                                                                        <td ><Skeleton /></td>
                                                                        <td ><Skeleton /></td>
                                                                        <td ><Skeleton /></td>
                                                                        <td ><Skeleton /></td>
                                                                    </tr>
                                                                ))
                                                            }

                                                            {(!isLoading && !getFilteredActivities()?.length) &&
                                                                <tr ><td colSpan="100%"><span>{t("noActivitiesFound")}</span></td></tr>
                                                            }

                                                            {!isLoading && getFilteredActivities()?.map((activity, index) => (

                                                                <tr key={index}>

                                                                    <td >

                                                                        <MuiTooltip placement="top" arrow title={props.role == 2 ? getFullName(activity?.consultant) : activity?.project?.client?.name}>
                                                                            <span>{trimElip(props.role == 2 ? getFullName(activity?.consultant) : activity?.project?.client?.name, 50)}</span>
                                                                        </MuiTooltip>
                                                                    </td>

                                                                    <td>
                                                                        <Stack direction="horizontal" gap={2}>

                                                                            <MuiTooltip placement="top" arrow title={<span style={{ whiteSpace: 'pre-line' }}>{activity?.name}<br />({activity?.code})</span>}>
                                                                                <span>{trimElip(activity?.name, 50)}</span>

                                                                            </MuiTooltip>
                                                                            {getFilesForActivities()?.find(x => x.activityId === activity?.id) && getCurrentMonthForActivity(activity)?.status >= 1 && <FontAwesomeIcon style={{ cursor: "pointer" }} onClick={() => setShowFiles(true)} title={t("file")} icon={(solid("file"))} size="sm" />}

                                                                            {(getCurrentMonthForActivity(activity)?.sentWinbiz && isAdmin()) ? (<FontAwesomeIcon title={`${t("winbizWageSynchronized")} (${formatDateTime(getCurrentMonthForActivity(activity)?.sentWinbiz)})`} icon={(solid("circle-check"))} color="green" size="2x" />) : ""}
                                                                            {activity?.confidential && <FontAwesomeIcon title={t("privacy")} icon={(solid("eye-slash"))} size="sm" />}

                                                                        </Stack>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            activity.workUnit == 4 ?
                                                                                <>
                                                                                    <Stack direction="horizontal" gap={1}>
                                                                                        <button className="btn btn-link btn-sm" style={{ padding: '0px' }}
                                                                                            onClick={() => { navigate(`/expenses/billed/${currentDate.getFullYear()}/${currentDate.getMonth() + 1}/${activity.id}`); }} >
                                                                                            <FontAwesomeIcon icon={solid("magnifying-glass")} style={{ fontSize: '10px' }} />
                                                                                            {getUnits(null, true).find(x => x.id === activity.workUnit)?.name}
                                                                                        </button>

                                                                                        <Button className="p-0" variant="secondary" size="sm" title={t("pdfReport")}
                                                                                            onClick={async () => {
                                                                                                setFileLoading({ type: "billed", id: activity.id });
                                                                                                //setShowReport(true);

                                                                                                await getBilledReport(currentDate.getFullYear(), currentDate.getMonth() + 1, activity.id)
                                                                                                    //.then((b) => saveAs(new Blob([b.bytes]), `BilledExpenseReport ${currentDate.getFullYear()} ${currentDate.getMonth()} ${activity.name} }.pdf`))
                                                                                                    .then((b) => {
                                                                                                        var fileReader = new FileReader();
                                                                                                        fileReader.onload = function (event) {
                                                                                                            setPdfData({
                                                                                                                data: event.target.result,
                                                                                                                filename: `${activity?.consultant?.username} ${currentDate.getFullYear()} ${lpad(currentDate.getMonth() + 1, 2)} Frais refactur\u00E9s ${activity.project.client.name}.pdf`//f.filename
                                                                                                            });
                                                                                                            setShowReport(true);
                                                                                                        };
                                                                                                        fileReader.readAsArrayBuffer(b.bytes);
                                                                                                        //saveAs(new Blob([b.bytes]), `${activity?.consultant?.username} ${currentDate.getFullYear()} ${lpad(currentDate.getMonth() + 1, 2)} Frais refactur\u00E9s ${activity.project.client.name}.pdf`)
                                                                                                    });
                                                                                                setFileLoading(null);

                                                                                            }
                                                                                            }
                                                                                        >{fileLoading && fileLoading?.type === "billed" && fileLoading?.id === activity.id ? <Spinner size="sm" animation="border" /> : < FontAwesomeIcon className="mx-1" icon={solid("file-lines")} size="1x" />}</Button>
                                                                                    </Stack>
                                                                                </> :
                                                                                <>
                                                                                    {getUnits().find(x => x.id == activity.workUnit)?.name}
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td align="right">

                                                                        <NumberFormatted number={getTotalForActivity(activity, currentDate)} />

                                                                    </td>

                                                                    {<td >
                                                                        <Stack direction="horizontal" className="align-items-center justify-content-center">


                                                                            {!isAdmin() &&
                                                                                (() => {
                                                                                    var isClient = props.role == 2;
                                                                                    switch (getCurrentMonthForActivity(activity)?.status) {
                                                                                        case 1://Pending validation
                                                                                            return <FontAwesomeIcon icon={solid("spinner")} size="2x" />
                                                                                            break;
                                                                                        case 2://Rejected
                                                                                            return <MuiTooltip placement="top" arrow title={<span style={{ whiteSpace: 'pre-line' }}>{getCurrentMonthForActivity(activity)?.statusMessage}</span>}>
                                                                                                <FontAwesomeIcon icon={solid("ban")} size="2x" />
                                                                                            </MuiTooltip>
                                                                                            break;
                                                                                        case 3://Validated                                                                                                
                                                                                            return <FontAwesomeIcon icon={regular("circle-check")} size="2x" />
                                                                                            break;
                                                                                        case 4://Validated
                                                                                            return isClient ? <FontAwesomeIcon icon={regular("circle-check")} size="2x" /> : <FontAwesomeIcon icon={solid("file-circle-check")} size="2x" />
                                                                                            break;
                                                                                        case 5://Billed
                                                                                            return isClient ? <FontAwesomeIcon icon={regular("circle-check")} size="2x" /> : <FontAwesomeIcon icon={solid("flag")} size="2xs" />
                                                                                            break;
                                                                                        default:
                                                                                            return null;
                                                                                            break;
                                                                                    }
                                                                                })()}


                                                                            {isAdmin() && //Show whether finalized item is billed or not
                                                                                (() => {
                                                                                    switch (getCurrentMonthForActivity(activity)?.status) {

                                                                                        case 5://Prebilled
                                                                                            return props.state == 5 && getCurrentMonthForActivity(activity)?.invoice?.id ?
                                                                                                <MuiTooltip placement="top" arrow title={`${t("invoice")} ${getCurrentMonthForActivity(activity)?.invoice?.number}`}>
                                                                                                    <FontAwesomeIcon icon={solid("file-invoice-dollar")} size="2x" /></MuiTooltip>
                                                                                                : null;
                                                                                            break;
                                                                                        case 2://Rejected
                                                                                            return props.state == 2 && <MuiTooltip placement="top" arrow title={<span style={{ whiteSpace: 'pre-line' }}>{getCurrentMonthForActivity(activity)?.statusMessage}</span>}>
                                                                                                <FontAwesomeIcon icon={solid("ban")} size="2x" />
                                                                                            </MuiTooltip>
                                                                                            break;
                                                                                        default:
                                                                                            return null;
                                                                                            break;
                                                                                    }
                                                                                })()}
                                                                        </Stack>
                                                                    </td>}

                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </Stack>
                                            </Container>

                                        </Col>
                                        <Col sm={7}>
                                            <Container className="border">
                                                <Stack>
                                                    <Stack direction="horizontal" style={{ margin: "4px 0px", backgroundColor: "#FFE2E5", borderRadius: "25px", padding: "0px 8px" }}>
                                                        <Button variant="outline" style={{ visibility: isAdmin() || isLoading ? "hidden" : null }} onClick={() => {
                                                            var newDate = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
                                                            setCurrent(newDate);
                                                            clearFilters();

                                                        }}>
                                                            <FontAwesomeIcon icon={solid("caret-left")} color="#B96A6A" size="1x" />
                                                        </Button>
                                                        <span className="w-100 text-center">
                                                            {isLoading ? <Skeleton /> : <b>{formatMonthYear(currentDate)}</b>}
                                                        </span>
                                                        <Button variant="outline" style={{ visibility: isAdmin() || isLoading ? "hidden" : null }} onClick={() => {
                                                            var newDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
                                                            setCurrent(newDate);
                                                            clearFilters();
                                                        }}>
                                                            <FontAwesomeIcon className="ms-auto" color="#B96A6A" icon={solid("caret-right")} size="1x" />
                                                        </Button>
                                                    </Stack>
                                                    <Form noValidate validated={formValidated} onSubmit={handleSubmitHours} ref={hoursForm}>
                                                        <Table responsive className="timesheet table-sm smaller">
                                                            <thead>
                                                                {isLoading && <tr key={0}>
                                                                    {Array.from({ length: 1 }).map((_, idx) => (<th key={idx}><Skeleton /></th>))}
                                                                </tr>}

                                                                {!isLoading && <tr key={0} >
                                                                    {Array.from({ length: getDaysInCurrentMonth(currentDate) }).map((_, idx) =>
                                                                        <th className={classnames("text-center", isWeekend(idx, currentDate) ? "weekend" : "")} key={idx}>{getDayName(idx, currentDate).toUpperCase()} {(idx + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })}</th>)
                                                                    }
                                                                </tr>}
                                                            </thead>

                                                            <tbody>
                                                                {(isLoading || !getFilteredActivities()) &&
                                                                    Array.from({
                                                                        length: skeletonCount /*+ (getFilteredActivities()?.length ?0:1)*/
                                                                    })?.map((_, idx) => (
                                                                        <tr key={idx}><td colSpan="100%"><Skeleton /></td></tr>
                                                                    ))
                                                                }
                                                                {(!isLoading && !getFilteredActivities()?.length) &&
                                                                    <tr><td colSpan="100%"><span>{t("noActivitiesFound")}</span></td></tr>
                                                                }
                                                                {!isLoading && getFilteredActivities()?.map((activity, index) => (
                                                                    <tr key={`tr_${activity.id}_${index}`}>

                                                                        {Array.from({ length: isAmountOrExpense(activity) ? 1 : getDaysInCurrentMonth(currentDate) }).map((_, idx, arr) => (
                                                                            <td colSpan={isAmountOrExpense(activity) ? "100%" : ""} key={`td_${buildRowKey(activity, idx)}`} className={classnames(isMonthEnabled(activity, idx) ? (isWeekend(idx, currentDate) && arr?.length > 1 ? "weekend" : "") : "month-disabled")}>

                                                                                {
                                                                                    isEditable(activity) && isMonthEnabled(activity, idx) ?

                                                                                        <TimesheetInput
                                                                                            useFormattedInput
                                                                                            readOnly={activity?.workUnit === 4}
                                                                                            className={activity?.workUnit === 4 ? "input-as-text" : ""}
                                                                                            isAmount={isAmountOrExpense(activity)}
                                                                                            formatInitBlur={(v) => { return isNaN(parseFloat(v)) ? "" : parseFloat(v)?.toFixed(2) }}
                                                                                            step={activity.workUnit <= 1 ? 0.25 : null}
                                                                                            name={buildRowKey(activity, idx)}
                                                                                            value={getValue(activity, idx, isAmountOrExpense(activity))}
                                                                                            //defaultValue={getDefaultValue(buildRowKey(activity, idx))}
                                                                                            onChange={(e) => {

                                                                                                updateValues(buildRowKey(activity, idx), e)
                                                                                            }}
                                                                                        />
                                                                                        :
                                                                                        <div className="timesheet-row">
                                                                                            <span className="text-center" style={{ width: "45px" }}>
                                                                                                {activity.workUnit !== 4 && isMonthEnabled(activity, idx) && getDefaultValue(buildRowKey(activity, idx))}
                                                                                            </span>
                                                                                        </div>
                                                                                }
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                ))}

                                                            </tbody>

                                                        </Table>

                                                    </Form>
                                                </Stack>
                                            </Container>

                                        </Col>
                                    </Row>

                                </Stack>


                            </Stack>

                        </div>

                    }
                </Card.Body>
            </Card>




        </Stack>
    );
});

export default observer(TimesheetItem);
